"use client";

import Link from "next/link";
import { useRef } from "react";

export type NavItem = { href: string; label: string; labelAr?: string };

export function MobileNav({ items }: { items: NavItem[] }) {
  const detailsRef = useRef<HTMLDetailsElement>(null);

  const closeMenu = () => {
    detailsRef.current?.removeAttribute("open");
  };

  return (
    <details ref={detailsRef} className="group relative md:hidden">
      <summary
        className="list-none cursor-pointer rounded-md px-2 py-1.5 text-2xl text-[var(--primary)] outline-none ring-[var(--accent)] focus-visible:ring-2 [&::-webkit-details-marker]:hidden"
        aria-label="Open menu"
      >
        ☰
      </summary>
      <div className="absolute right-0 mt-2 w-52 rounded-xl border border-slate-200 bg-white py-2 shadow-xl">
        {items.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            onClick={closeMenu}
            className="block px-4 py-2.5 text-sm font-medium text-slate-800 hover:bg-slate-50"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </details>
  );
}
